import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import { CircularProgress, Paper, Typography } from "@material-ui/core";
import { baseUrlRate, LOCAL_STORAGE_KEY } from "../../../config";
import { getUserData } from "../../common/utility/Utils";
import { path } from "../../../order_managment/constants/apiPath";
import axios from "axios";
import { NotificationManager } from "react-notifications";
import { useState } from "react";
import routeConstant from "../../../route/compoent/routeConstant";
import { useNavigate } from "react-router-dom";
import { useContext } from "react";
import { StoreContext } from "../../../store/Provider";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function DailogueRms({
  status,
  dailogueOpen,
  setDailogueOpen,
  quoteResult,
  details,
  bookedindex,
}) {
  const handleClose = () => {
    setDailogueOpen(false);
  };
  const context = useContext(StoreContext);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  console.log("Quote results :", quoteResult);
  console.log("Quote details :", details);

  const onClickBookQuote = async () => {
    setLoading(true);
    let data = {};
    await getUserData(LOCAL_STORAGE_KEY.user_token)
      .then((res) => {
        data = res;
      })
      .catch((err) => {
        console.log(err);
      });
    const header = {
      Authorization: `Bearer ${data.access_token}`,
      UserName: data.user_name,
      UserSecret: data.password,
      DeviceType: "W",
      MacAddress: "",
      IPAddress: "",
    };
    let url;
    if (status === "LCL") url = `${baseUrlRate}${path.BOOK_QUOTE}`;
    else url = `${baseUrlRate}${path.BOOK_FCL_QUOTE}`;
    const body = {
      quote_BookingId: quoteResult?.quote_BookingId ?? "",
      bookingMadeByUserId: quoteResult?.bookingMadeByUserId ?? "",
    };

    axios
      .put(url, body, {
        headers: header,
      })
      .then((res) => {
        setLoading(false);
        NotificationManager.success(
          "Your quote is booked successFully",
          "",
          3000
        );

        setDailogueOpen(false);
        if (status === "LCL") navigate(routeConstant.LCL);
        else navigate(routeConstant.FCL);
      })
      .catch((err) => {
        NotificationManager.error("Something went wrong!", "", 3000);
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <div>
      <Dialog
        fullWidth
        maxWidth={"md"}
        open={dailogueOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle>{"Quote Description"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div className="d-flex justify-content-start">
              <div>
                {" "}
                <Typography>
                  Quote id : <b>{quoteResult?.quote_BookingId}</b>
                </Typography>
                <Typography>
                  Booking made by : <b>{quoteResult?.bookingMadeByUserId}</b>
                </Typography>
                <Typography>
                  Origin :{" "}
                  <b>
                    {details?.origin?.origin}
                    {status === "LCL" && ` (${details?.origin?.originCode})`}
                    {/* ({details?.origin?.originCode}) */}
                  </b>
                </Typography>
                <Typography>
                  Destination :{" "}
                  <b>
                    {details?.destination?.destination}
                    {status === "LCL" &&
                      ` (${details?.destination?.destinationCode})`}
                  </b>
                </Typography>
                {status === "FCL" && (
                  <Typography>
                    Transit Time : <b>{quoteResult?.tT_to_POD ?? "0"} Days</b>
                  </Typography>
                )}
                {status === "LCL" && (
                  <Typography>
                    Quantity (in CBM) : <b>{quoteResult?.ipiQty ?? "0"}</b>
                  </Typography>
                )}
                <Typography>
                  Total quote amount :{" "}
                  <b>
                    {"USD"} {quoteResult?.totalQuotedAmount.toFixed(2)}
                  </b>
                </Typography>
              </div>
              {status === "FCL" && (
                <div
                  style={{
                    width: "16rem",
                    height: "9rem",
                    // backgroundColor: "pink",
                    paddingLeft: "20px",
                  }}
                >
                  <span style={{ fontSize: "24px" }}>
                    <b>Charge Breakup:</b>
                  </span>
                  {quoteResult?.isGP20ContainerSelected && (
                    <Typography
                      style={{ fontSize: "18px", paddingLeft: "10px" }}
                    >
                      20GP :{" "}
                      <b>{`${quoteResult?.gP20ContainerRate} * ${
                        quoteResult?.gP20ContainerCount
                      } = ${(
                        quoteResult?.gP20ContainerRate *
                        quoteResult?.gP20ContainerCount
                      ).toFixed(2)}`}</b>
                    </Typography>
                  )}
                  {quoteResult?.isGP40ContainerSelected && (
                    <Typography
                      style={{ fontSize: "18px", paddingLeft: "10px" }}
                    >
                      40GP :{" "}
                      <b>{`${quoteResult?.gP40ContainerRate} * ${
                        quoteResult?.gP40ContainerCount
                      } = ${(
                        quoteResult?.gP40ContainerRate *
                        quoteResult?.gP40ContainerCount
                      ).toFixed(2)}`}</b>
                    </Typography>
                  )}
                  {quoteResult?.isHQ40ContainerSelected && (
                    <Typography
                      style={{ fontSize: "18px", paddingLeft: "10px" }}
                    >
                      40HQ :{" "}
                      <b>{`${quoteResult?.hQ40ContainerRate} * ${
                        quoteResult?.hQ40ContainerCount
                      } = ${(
                        quoteResult?.hQ40ContainerRate *
                        quoteResult?.hQ40ContainerCount
                      ).toFixed(2)}`}</b>
                    </Typography>
                  )}
                  {quoteResult?.isHQ45ContainerSelected && (
                    <Typography
                      style={{ fontSize: "18px", paddingLeft: "10px" }}
                    >
                      45HQ :{" "}
                      <b>{`${quoteResult?.hQ45ContainerRate} * ${
                        quoteResult?.hQ45ContainerCount
                      } = ${(
                        quoteResult?.hQ45ContainerRate *
                        quoteResult?.hQ45ContainerCount
                      ).toFixed(2)}`}</b>
                    </Typography>
                  )}
                  {quoteResult?.isNOR40ContainerSelected && (
                    <Typography
                      style={{ fontSize: "18px", paddingLeft: "10px" }}
                    >
                      40NOR :{" "}
                      <b>{`${quoteResult?.noR40ContainerRate} * ${
                        quoteResult?.noR40ContainerCount
                      } = ${(
                        quoteResult?.noR40ContainerRate *
                        quoteResult?.noR40ContainerCount
                      ).toFixed(2)}`}</b>
                    </Typography>
                  )}

                  <Typography style={{ fontSize: "18px", paddingLeft: "10px" }}>
                    Custom Clearance :{" "}
                    <b>{quoteResult?.customClearaceAmount}</b>
                  </Typography>
                  <Typography style={{ fontSize: "18px", paddingLeft: "10px" }}>
                    Insurance Amount : <b>{quoteResult?.insuraceAmount}</b>
                  </Typography>
                </div>
              )}
            </div>
          </DialogContentText>
        </DialogContent>

        <Typography
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "red",
            padding: "0.3rem 0",
            textAlign: "center",
          }}
        >
          {/* This Quotation is subject to in and out warehouse charges */}
          {status === "LCL" && (
            <>
              {" "}
              Rates are valid 2 weeks from the date of quote creation. Rates are
              included the warehouse in and out charges.
            </>
          )}
        </Typography>

        <DialogActions>
          <button
            style={{ minWidth: "7rem" }}
            className="btn btn-danger"
            onClick={handleClose}
          >
            Cancel
          </button>
          {!context.omsUserData?.UserRoles.includes("Admin") ? (
            <button
              style={{ minWidth: "7rem" }}
              className="btn btn-primary"
              onClick={onClickBookQuote}
            >
              {loading ? (
                <CircularProgress color="#fff" size="1rem" />
              ) : (
                "Book Quote"
              )}
            </button>
          ) : null}
        </DialogActions>
      </Dialog>
    </div>
  );
}
